import { getTokenManager } from "@Auth/session";
import { ulid } from "ulid";
import { useChatComposerStore } from "../v2/store/chatComposerStore";
import { useChatSessionStore } from "../v2/store/chatSessionStore";
const LEGACY_CHAT_ID_SETTING = "chatId";
function chatIdSetting() {
    const state = getTokenManager().getState();
    const id = state.status === "signedIn" ? state.session.user.id : undefined;
    return id === undefined ? null : `chatV3Id:${id}`;
}
export function readChatId() {
    const { settings } = Office.context.document;
    const key = chatIdSetting();
    return (key && settings.get(key)) ?? settings.get(LEGACY_CHAT_ID_SETTING) ?? null;
}
export function createNewChat() {
    const chatId = ulid();
    const key = chatIdSetting();
    if (key) {
        Office.context.document.settings.set(key, chatId);
        Office.context.document.settings.saveAsync();
    }
    const store = useChatSessionStore.getState();
    store.setChatId(chatId);
    store.setIsNewChat(true);
    useChatComposerStore.setState({
        connections: [],
        attachments: []
    });
    return chatId;
}
